import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error("Missing Supabase credentials in environment variables.");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Required for secure MFA handling and cross-domain persistence
    flowType: 'pkce',
    storageKey: 'nexus-protocol-session', 
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

/**
 * Sovereign Ledger Fetchers
 */

export async function getStamps() {
  const { data, error } = await supabase
    .from('stamps')
    .select('*')
    .order('created_at', { ascending: false });
  
  if (error) {
    console.error("Ledger retrieval error:", error.message);
    throw error;
  }
  return data;
}

export async function getIdentity() {
  const { data, error } = await supabase
    .from('identity')
    .select('*')
    .maybeSingle();
  
  if (error) throw error;
  return data;
}